import React, { forwardRef, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

const DISPLAY_ORDER = ['AAA', 'AA', 'A', 'BBB', 'BB and Lower'];

const CreditExposureBarChart = forwardRef(({ data, colours = {} }, ref) => {
  const barColor = colours.credit_bar || '#337B91';

  const chartData = useMemo(() => {
    if (!data) return null;

    const labels = [];
    const values = [];

    for (const grade of DISPLAY_ORDER) {
      if (data[grade] != null && data[grade] > 0) {
        labels.push(grade);
        values.push(data[grade]);
      }
    }

    if (labels.length === 0) return null;

    return {
      labels,
      datasets: [{
        data: values,
        backgroundColor: barColor,
        barPercentage: 0.7,
      }],
    };
  }, [data, barColor]);

  if (!chartData) {
    return <div className="chart-placeholder">No credit exposure data available</div>;
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { display: false },
        ticks: { font: { size: 10 } },
      },
      y: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val}%`,
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: '50mm' }}>
      <Bar ref={ref} data={chartData} options={options} />
    </div>
  );
});

CreditExposureBarChart.displayName = 'CreditExposureBarChart';
export default CreditExposureBarChart;
